// extracted by mini-css-extract-plugin
module.exports = {"plCard":"Card_plCard__0MjGV"};